import { render, staticRenderFns } from "./ReserveIndex.vue?vue&type=template&id=99fb5486&scoped=true&"
import script from "./ReserveIndex.vue?vue&type=script&lang=js&"
export * from "./ReserveIndex.vue?vue&type=script&lang=js&"
import style0 from "./ReserveIndex.vue?vue&type=style&index=0&id=99fb5486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fb5486",
  null
  
)

export default component.exports